import { memo } from 'react';
import { t } from 'i18next';
import { Stack } from '@mui/system';
import { Divider } from '@mui/material';

import { Accordion } from '@common/components/Accordion';
import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { useReadSelectedAreas } from '@/modules/floorplanDesign/hooks';
import { JitRoutingPointProperties } from '@/modules/jitRoutingPoints/components/JitRoutingPointProperties';

import { LaneDirection } from './highway/LaneDirection';
import { HighwayConnectNeighbors } from './highway/HighwayConnectNeighbors';
import { HighwayConnectUturns } from './highway/HighwayConnectUturns';
import { HighwaySpacing } from './highway/HighwaySpacing';
import { VehicleLimit } from './highway/VehicleLimit';
import { Thickness } from './highway/Thickness';
import { MultiVehicleType } from './common/VehicleType';
import { SegmentDimensions } from './SegmentDimensions';
import { HighwayDimensions } from './HighwayDimensions';

function HighwayAreaParametersComponent() {
  const selectedAreas = useReadSelectedAreas();
  const selectedHighwayArea =
    selectedAreas.highwayAreas.length === 1 ? selectedAreas.highwayAreas[0] : null;

  if (!selectedHighwayArea) return null;

  const segmentedHighway = selectedHighwayArea.segments.length > 1;

  return (
    <Stack spacing={1} divider={<Divider />}>
      {segmentedHighway ? <SegmentDimensions mode='highway' /> : <HighwayDimensions />}
      <Accordion
        title={t<string>('interface:properties.highway.highway_title', 'Highway')}
        unmountOnExit
        defaultExpanded
        sx={{ px: 2 }}
      >
        <Stack direction='column' spacing={1}>
          <Thickness selectedHighway={selectedHighwayArea} />
          <Accordion title='Vehicle settings' unmountOnExit defaultExpanded>
            <Stack direction='column' spacing={1}>
              <MultiVehicleType />
            </Stack>
          </Accordion>
          <PropertiesLabel i18nkey='interface:properties.highway.lane_direction'>
            <LaneDirection selectedHighway={selectedHighwayArea} />
          </PropertiesLabel>
          <PropertiesLabel i18nkey='interface:properties.highway.connect_neighbors'>
            <HighwayConnectNeighbors selectedHighwayArea={selectedHighwayArea} />
          </PropertiesLabel>
          <PropertiesLabel i18nkey='interface:properties.highway.connect_uturns'>
            <HighwayConnectUturns selectedHighwayArea={selectedHighwayArea} />
          </PropertiesLabel>
          <HighwaySpacing />
          {/* <HighwayPoiPreferences selectedHighwayArea={selectedHighwayArea} /> for now, we hide this, this will be added back in the future. */}
          <VehicleLimit />
        </Stack>
      </Accordion>
      <JitRoutingPointProperties selectedHighway={selectedHighwayArea} />
    </Stack>
  );
}

export const HighwayAreaParameters = memo(HighwayAreaParametersComponent);
